module.exports = __webpack_public_path__ + "media/images/client/MediaReviews/mayak-103e51ed7ab3bab717f748cafe7ded55.svg";